import { useState } from 'react';
import { Badge, Card, Icon } from '../../../shared/ui/Primitives';
import type { ExampleSuggestion, Page01Snapshot } from '../adapters/demo-reader';

export function WarningPanel({
  snapshot,
  retry,
}: {
  snapshot: Page01Snapshot;
  retry: () => Page01Snapshot['warnings'];
}) {
  const [attempts, setAttempts] = useState(0);
  const [reading, setReading] = useState(false);
  const [warningStatus, setWarningStatus] = useState(snapshot.warnings);
  async function reread() {
    setReading(true);
    await new Promise((resolve) => window.setTimeout(resolve, 350));
    setWarningStatus(retry());
    setAttempts((value) => value + 1);
    setReading(false);
  }
  return (
    <Card zone="Z08" title="预警情报" extra={<span className="p01-muted">示例资料</span>}>
      {warningStatus === 'error' ? (
        <div className="p01-empty p01-local-error" role="status">
          <Icon name="alert" />
          <h3>{reading ? '正在重新读取预警情报…' : '预警情报读取失败'}</h3>
          <p>暂时无法取得该模块资料。其他模块保留。</p>
          <button
            disabled={reading}
            onClick={() => {
              void reread();
            }}
          >
            <Icon name="refresh" />
            重新读取
          </button>
          <p className="p01-muted">
            {attempts > 0
              ? `已重试 ${attempts} 次；错误演示仍生效，未回退到示例成功。`
              : '此读取结果不表示设备不可用或不能调度。'}
          </p>
        </div>
      ) : (
        <ul className="p01-warning-list">
          {snapshot.data.warnings.map((item) => (
            <li key={item.name}>
              <span className={`p01-icon-disc p01-${item.color}`}>
                <Icon name={item.level === '信息' ? 'info' : 'alert'} />
              </span>
              <div>
                <h3>{item.name}</h3>
                <p className="p01-muted">
                  {item.source} · {item.region}
                </p>
              </div>
              <div className="p01-warning-meta">
                <Badge tone={item.color}>{item.level}</Badge>
                <time>{item.time}</time>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
export function SuggestionPanel({
  snapshot,
  show,
}: {
  snapshot: Page01Snapshot;
  show: (suggestion: ExampleSuggestion) => void;
}) {
  return (
    <Card zone="Z09" title="建议行动">
      <p className="p01-authority">辅助建议 · 不构成操作授权</p>
      <ul className="p01-suggestion-list">
        {snapshot.data.suggestions.map((item) => (
          <li key={item.name}>
            <span className={`p01-icon-disc p01-${item.color}`}>
              <Icon name={item.icon} />
            </span>
            <div>
              <h3>{item.name}</h3>
              <p className="p01-muted">{item.summary}</p>
              <button className="p01-text-button" onClick={() => show(item)}>
                {item.action}
                <Icon name="arrow" />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
